import { collection, doc, limit, onSnapshot, orderBy, query, where } from "firebase/firestore";
import type { DayKey, LinhaDaTemporada } from "@nhomi/core";
import { db } from "./ambiente";

/* ============================================================
   Temporadas e conquistas — só leitura. Quem escreve é o servidor
   (`functions/src/temporadas.ts` e o registro de missões em
   `scoring.ts`); a regra recusa qualquer escrita do cliente.
   ============================================================ */

export interface Temporada {
  /** A segunda-feira da semana — é o id do documento. */
  de: DayKey;
  ate: DayKey;
  placar: LinhaDaTemporada[];
  campeoes: string[];
}

export type Conquista =
  | { id: string; uid: string; tipo: "missao"; eventId: string; nome: string; emoji: string; bonus: number; day: DayKey }
  | { id: string; uid: string; tipo: "campeao"; semana: DayKey; ate: DayKey; pontos: number };

/** As últimas semanas fechadas, da mais nova para a mais velha. */
export function watchTemporadas(cid: string, cb: (lista: Temporada[]) => void, quantas = 12): () => void {
  return onSnapshot(
    query(collection(db, "challenges", cid, "temporadas"), orderBy("de", "desc"), limit(quantas)),
    (snap) => cb(snap.docs.map((d) => d.data() as Temporada)),
    () => cb([]),
  );
}

/** Uma semana fechada específica (para a tela de pódio). */
export function watchTemporada(cid: string, de: DayKey, cb: (t: Temporada | null) => void): () => void {
  return onSnapshot(
    doc(db, "challenges", cid, "temporadas", de),
    (s) => cb(s.exists() ? (s.data() as Temporada) : null),
    () => cb(null),
  );
}

/** As conquistas de uma pessoa neste desafio. */
export function watchConquistas(cid: string, uid: string, cb: (lista: Conquista[]) => void): () => void {
  return onSnapshot(
    query(collection(db, "challenges", cid, "conquistas"), where("uid", "==", uid)),
    (snap) => cb(snap.docs.map((d) => ({ id: d.id, ...d.data() }) as Conquista)),
    () => cb([]),
  );
}
